import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import './ForgotPassword.css';

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3 6.75A1.75 1.75 0 0 1 4.75 5h14.5A1.75 1.75 0 0 1 21 6.75v10.5A1.75 1.75 0 0 1 19.25 19H4.75A1.75 1.75 0 0 1 3 17.25V6.75Z" stroke="currentColor" strokeWidth="1.6"/>
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.6" fill="none"/>
  </svg>
);

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccess] = useState('');
  const [errorMessage, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');

    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    try {
      await axiosInstance.post('/User/reset-password', { email: email.trim() });
      setSuccess('Password reset email sent. Please check your inbox.');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset link.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fp-page" style={{
      backgroundImage: `url('/images/login-background.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    }}>
      <div className="fp-card">
        <h1 className="fp-title">Forgot Password</h1>
        <p className="fp-sub">
          Enter the email associated with your account and we’ll send you a link to reset your password.
        </p>

        {successMessage && <div className="fp-alert fp-alert--success">{successMessage}</div>}
        {errorMessage && <div className="fp-alert fp-alert--error">{errorMessage}</div>}

        <form className="fp-form" onSubmit={handleForgotPassword} noValidate>
          <label htmlFor="email" className="fp-label">Email</label>
          <div className="fp-inputWrap">
            <input
              id="email"
              type="email"
              className="fp-input"
              placeholder="you@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              autoComplete="email"
              required
            />
            <span className="fp-icon" aria-hidden="true"><MailIcon /></span>
          </div>

          <button type="submit" className="fp-btn" disabled={isLoading}>
            {isLoading ? 'Sending…' : 'Send Reset Link'}
          </button>

          <div className="fp-links">
            <Link to="/login" className="fp-link">Back to login</Link>
          </div>
        </form>

        {/* Footer with tiny logo + copyright */}
        <div className="fp-footer">
          <a
            href="https://lanesands.io"
            target="_blank"
            rel="noreferrer"
            aria-label="Nnetego homepage"
          >
            <img
              className="fp-footer-logo"
              src="https://lanesands.io/images/logo.png"
              alt="Nnetego logo"
              loading="lazy"
            />
          </a>
          <small>© 2025 Nnetego. All rights reserved.</small>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
